import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Phase, ProjectV2, SectionOpInvest } from '@app/interfaces';
import { CoreModule } from '@app/modules/core/core.module';
import { PipesModule } from '@app/pipes';

@Component({
  selector: 'mnf-pi-v2-opp-investment',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './pi-v2-opp-investment.component.html',
  styleUrl: './pi-v2-opp-investment.component.scss'
})
export class PiV2OppInvestmentComponent implements OnInit {

  @Input() infoProject: ProjectV2;
  @Input() opSection: SectionOpInvest;
  @Input() detailsData: string[];
  phase: Phase;


  ngOnInit(): void  {
    this.phase = this.infoProject.phase;
    this.opSection = this.infoProject.newProject.sectionOpInvest;
  }

}
